import React, { Component } from 'react';
import swal from 'sweetalert';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { selectMembershipType, selectMembershipPackage, fetchMembershipTypes, fetchMembershipPackages } from '../../../../../../../Redux/Actions/EndUser/MembershipAction';
import { fetchAllMemberships, updateAdminMembership, addAdminMembership } from '../../../../../../../Redux/Actions/Admin/ManageMembershipActions';
import { getCounties, setCounties } from '../../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import '../../../ManageMembership/ManageMembership.scss';

import {
    addToPurchase,
    updatePurchase,
    changeView
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

class Membership extends Component {
    constructor(props) {
        super(props);
        this.state = {
            membershipInEdit: {},
            value: [],
            view: "Membership",
            total: "",
            id: 0,
            UserId: "",
            Name: "",
            ActualCost: "",
            SuggestedCost: 0,
            organizationName: "",
            firstName: this.props.purchaseAndRenewals.userInfo.firstName || "",
            lastName: this.props.purchaseAndRenewals.userInfo.lastName || "",
            email: this.props.purchaseAndRenewals.userInfo.email || "",
            mailingAddress1: this.props.purchaseAndRenewals.userInfo.address1 || "",
            mailingAddress2: this.props.purchaseAndRenewals.userInfo.address2 || "",
            mailingCity: this.props.purchaseAndRenewals.userInfo.city || "",
            mailingZip: this.props.purchaseAndRenewals.userInfo.zip || "",
            mailingStateId: this.props.purchaseAndRenewals.userInfo.state.stateId,
            state: this.props.purchaseAndRenewals.userInfo.state,
            countyObj: this.props.purchaseAndRenewals.userInfo.countyObj,
            county: this.props.purchaseAndRenewals.userInfo.countyObj.countyName || "",
            phone: this.props.purchaseAndRenewals.userInfo.phone || "",
            additionalHead: 1,
            referredBy: "",
            membershipPackage: {},
            membershipType: {},
            touched: {
                organizationName: false,
                firstName: false,
                lastName: false,
                email: false,
                mailingCity: false,
                mailingAddress1: false,
                county: true,
                mailingZip: false,
                phone: false
            },
        };
    }
    componentDidMount() {
        this.props.fetchAllMemberships();
        this.props.fetchMembershipTypes();
        this.props.fetchStates();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }
    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }
    isCustom(item) {
        return item.id === undefined;
    }
    addKey(item) {
        item.id = new Date().getTime();
    }
    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            ...edited
        });
    };

    handleMultiSelectChange = (event) => {
        var currentState = { ...this.state };
        currentState.permissions = [...event.target.value];
        this.setState({
            ...currentState
        });
    };

    handleChange = (event) => {
        this.selectedMembershipType(event.target.value);
    }

    selectedMembershipType = (value) => {
        this.props.selectMembershipType(value);
        if (value !== null) {

            const newState = Object.assign({}, this.state);
            newState.membershipType = value;
            newState.membershipPackage = {};
            this.setState(
                newState
            );
            this.props.fetchMembershipPackages(value.membershipTypeID);
        }
    }

    handlePackageChange = (event) => {
        const newState = Object.assign({}, this.state);
        newState.membershipPackage = event.target.value;
        this.setState(newState);
        this.props.selectMembershipPackage(event.target.value);
    }

    handleState = (event) => {
        this.props.getCounties(event.target.value.id);
        const value = event.target.value;
        if (value !== null) {
            this.setState({
                mailingStateId: value.id,
            });
        }
    };

    selectCountyInDD = (event) => {
        this.setState({
            countyObj: event.target.value
        })
    }

    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    handlePhoneChange = (event) => {
        var newphone = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: newphone
        });
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                organizationName: true,
                firstName: true,
                lastName: true,
                email: true,
                mailingCity: true,
                county: true,
                mailingAddress1: true,
                zip: true,
                phone: true
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        //(this.state.membershipType.membershipTypeID != 5 ? this.state.organizationName !== "" : true) &&

        return this.state.firstName !== "" &&
            this.state.lastName !== "" &&
            this.state.email !== "" &&
            this.state.mailingAddress1 !== "" &&
            this.state.mailingCity !== "" &&
            this.state.countyObj.countyName !== "" &&
            this.state.zip !== "" &&
            this.state.phone !== "";
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            event.preventDefault();
            const newState = Object.assign({}, this.state);
            if (this.state.membershipPackage.description === "3000+ head" && this.state.membershipType.description === "Standard") {
                newState.ActualCost = newState.membershipPackage.cost + (1.36 * this.state.additionalHead);
                newState.SuggestedCost = Number(Number(newState.membershipPackage.cost) + Number(1.36 * this.state.additionalHead));
            } else {
                newState.ActualCost = Number(newState.membershipPackage.cost);
                newState.SuggestedCost = Number(newState.membershipPackage.cost);
            }
            newState.additionalHead = parseInt(newState.additionalHead);
            newState.Name = newState.firstName + " " + newState.lastName;
            this.setState(newState);
            if (this.props.purchaseAndRenewals.editingPurchase.Name) {
                this.props.updatePurchase(newState);
            } else {
                this.props.addToPurchase(newState);
            }
            this.props.changeView({ view: "AddItems" })
        } else {
            this.setAllTouchedTrue();
        }
    };

    render() {
        return (
            <form className="user-form membership-form" onSubmit={this.handleSubmit}>
                <div className="form-group">
                    <h2 className="callout">Enter <span className="highlight">Member Information</span></h2>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="membershipType">Membership Type</label>
                        <DropDownList data={this.props.membership.membershipTypes}
                            textField="description"
                            dataItemKey="membershipTypeID"
                            onChange={this.handleChange}
                            value={this.state.membershipType}
                            //allowCustom={false}
                            //filterable={false}
                            //clearButton={false}
                            width={300}
                            required={true}
                            valid={Object.keys(this.state.membershipType).length > 0}
                            name="membershipType"
                            id="membershipType"

                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="membershipPackage">Membership Package</label>
                        <DropDownList data={this.props.membership.membershipPackages}
                            textField="description"
                            dataItemKey="membershipPackageID"
                            onChange={this.handlePackageChange}
                            value={this.state.membershipPackage}
                            //allowCustom={false}
                            //filterable={false}
                            //clearButton={false}
                            width={300}
                            required={true}
                            valid={Object.keys(this.state.membershipPackage).length > 0}
                            name="membershipPackage"
                            id="membershipPackage"
                        />
                    </div>
                </div>
                {
                    this.state.membershipPackage.description === "3000+ head" && this.state.membershipType.description === "Standard" ?
                        <div className="row">
                            <div className="membershipID form-group col-md-12">
                                <label htmlFor="additionalHead" className="">Add additional head number over 3000.</label>
                                <Input
                                    id="additionalHead"
                                    min="1"
                                    type="number"
                                    value={this.state.additionalHead}
                                    onChange={this.onDialogInputChange}
                                    name="additionalHead"
                                />
                            </div>
                        </div>
                    : ""
                }
                <div className="row">
                    {
                        this.state.membershipType.membershipTypeID == 5 ? ''
                            :
                            <div className="membershipID form-group col-md-12">
                                <label htmlFor="organizationName" className="">Family/Group/Organization Name - what name would you like on your membership ID card and magazine?</label>
                                <Input
                                    id="organizationName"
                                    type="text"
                                    name="organizationName"
                                    value={this.state.organizationName}
                                    onChange={this.onDialogInputChange}
                                    //invalid={this.state.touched.organizationName && this.state.organizationName === '' ? "error" : ""}
                                    //required={true}
                                    onBlur={this.handleBlur('organizationName')}
                                />
                            </div>
                    }
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="firstName">First Name</label>
                        <Input
                            type="text"
                            name="firstName"
                            value={this.state.firstName || ''}
                            onChange={this.onDialogInputChange}
                            id="firstName"
                            //invalid={this.state.touched.firstName && this.state.firstName === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('firstName')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="lastName">Last Name</label>
                        <Input
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={this.state.lastName || ''}
                            onChange={this.onDialogInputChange}
                            //invalid={this.state.touched.lastName && this.state.lastName === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('lastName')}
                        />
                    </div>
                </div>
                <div className="row">                    
                    <div className="form-group col-md-6">
                        <label htmlFor="email">Email</label>
                        <Input
                            required={true}
                            type="email"
                            name="email"
                            id="email"
                            value={this.state.email || ''}
                            onChange={this.onDialogInputChange}
                            //invalid={this.state.touched.email && this.state.email === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('email')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="referredBy" className="">Referred By <br /> </label>
                        <Input
                            id="referredBy"
                            type="text"
                            value={this.state.referredBy}
                            onChange={this.onDialogInputChange}
                            invalid={this.state.touched.referredBy && this.state.referredBy === '' ? "error" : ""}
                            //required={true}
                            name="referredBy"
                        />
                    </div>
                </div>
                <div className="form-group ">
                    <h2 className="callout">Enter <span className="highlight">Mailing Address</span></h2>
                </div>
                <div className="mailingAddressContainer row">
                    <div className="address1-wrapper form-group col-md-6">
                        <label htmlFor="mailingAddress1">Address 1</label>
                        <Input
                            id="mailingAddress1"
                            type="text"
                            value={this.state.mailingAddress1}
                            onChange={this.onDialogInputChange}
                            name="mailingAddress1"
                            //invalid={this.state.touched.mailingAddress1 && this.state.mailingAddress1 === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('mailingAddress1')}
                        />
                    </div>
                    <div className="address2-wrapper form-group col-md-6">
                        <label htmlFor="mailingAddress2">Address 2</label>
                        <Input
                            id="mailingAddress2"
                            type="text"
                            value={this.state.mailingAddress2}
                            onChange={this.onDialogInputChange}
                            name="mailingAddress2"
                        />
                    </div>
                </div>
                <div className="cityStateZip row">
                    <div className="city-wrapper form-group col-md-3">
                        <label htmlFor="mailingCity">City</label>
                        <Input
                            id="mailingCity"
                            type="text"
                            value={this.state.mailingCity}
                            onChange={this.onDialogInputChange}
                            name="mailingCity"
                            //invalid={this.state.touched.mailingCity && this.state.mailingCity === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('mailingCity')}
                        />
                    </div>
                    <div className="state-wrapper form-group col-md-3">
                        <label htmlFor="State">State</label>
                        <DropDownList data={this.props.common.states}
                            id="State"
                            name="state"
                            textField="name"
                            dataItemKey="id"
                            onChange={this.handleState}
                            value={this.state.state}
                            required={true}
                        />
                    </div>
                    {
                        this.props.district.counties.length > 0 ?
                            <div className="form-group col-md-3">
                                <label htmlFor="County" className={this.state.touched.county === '' ? "error" : ""}>County</label>
                                <DropDownList data={this.props.district.counties}
                                    id="County"
                                    name="county"
                                    textField="countyName"
                                    dataItemKey="countyId"
                                    onChange={this.selectCountyInDD}
                                    value={this.state.countyObj}
                                    className={this.state.touched.county && this.state.countyObj.countyName === '' ? "error" : ""}
                                    onBlur={this.handleBlur('county')}
                                    required={true}
                                />
                            </div>
                        : ""
                    }
                    <div className="zip-wrapper form-group col-md-3">
                        <label htmlFor="mailingZip">Zip</label>
                        <Input
                            id="MailingZip"
                            validityStyles={false}
                            value={this.state.mailingZip}
                            onChange={this.onDialogInputChange}
                            name="mailingZip"
                            pattern="(\d{5}([\-]\d{4})?)"
                            type="text"
                            placeholder="12345"
                            title="Zip Code (Format: 12345 or 12345-6789)"
                            //invalid={this.state.touched.zip && this.state.zip === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('mailingZip')}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="phone">Phone</label>
                        <Input
                            type="text"
                            name="phone"
                            id="phone"
                            pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                            title="Phone Number (Format: (123) 456-7890)"
                            placeholder="(123) 456-7890"
                            value={this.state.phone || ''}
                            onChange={this.handlePhoneChange}
                            //invalid={this.state.touched.phone && this.state.phone === '' ? "error" : ""}
                            required={true}
                            onBlur={this.handleBlur('phone')}
                        />
                    </div>
                </div>
                <div className="footer">
                    <div className="form-group">
                        <button type="submit" className="admin-k-button">
                            <i className="fas fa-save"></i>
                            <span>SAVE</span>
                        </button>
                        <button className="admin-k-button" onClick={() => this.props.changeView({ view: "AddItems" })}>
                            <i className="fas fa-times"></i>
                            <span>CANCEL</span>
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        common: state.common,
        district: state.district,
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    fetchStates,
    fetchAllMemberships,
    fetchMembershipTypes,
    fetchMembershipPackages,
    selectMembershipType,
    selectMembershipPackage,
    addAdminMembership,
    updateAdminMembership,
    addToPurchase,
    updatePurchase,
    changeView,
    getCounties
})(Membership);